module.exports = __webpack_public_path__ + "static/media/MK-Logo.d7840fd1.png";